import { getAttendanceStatus, getAllQueue } from "./offline_queue";

export async function resolveOfflineStatus() {
    const today = new Date().toISOString().slice(0, 10)
    const serverStatus = await getAttendanceStatus()
    const queue = await getAllQueue()
    const todayQueue = queue.filter(q => q.createdAt?.slice(0, 10) === today)

    const hasClockIn = (serverStatus?.date === today && serverStatus?.showed_up_at) || todayQueue.some(q => q.type === "clock_in")
    const hasClockOut = (serverStatus?.date === today && serverStatus?.left_at) || todayQueue.some(q => q.type === "clock_out")

    if (hasClockIn && hasClockOut) return "left"
    if (hasClockIn) return "showed_up"
    return "no_record"
}

export function renderBadge(status) {
    const badgeMap = {
        vacation: { class: "bg-warning", text: "「休暇」" },
        left: { class: "bg-success", text: "「退勤」" },
        showed_up: { class: "bg-info", text: "「出勤」" },
        no_record: { class: "bg-danger", text: "「打刻なし」" }
    }

    const badge = badgeMap[status] || badgeMap["no_record"]
    const syncEl = document.querySelector('[data-controller="attandances--status-sync"]')
    const container = syncEl.nextElementSibling

    if (container) {
        container.innerHTML = `<span class="badge ${badge.class} rounded-pill">${badge.text}</span>`
    }
}